import { render, staticRenderFns } from "./BuyTicket.vue?vue&type=template&id=a1ab1cae&scoped=true&"
import script from "./BuyTicket.vue?vue&type=script&lang=js&"
export * from "./BuyTicket.vue?vue&type=script&lang=js&"
import style0 from "./BuyTicket.vue?vue&type=style&index=0&id=a1ab1cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ab1cae",
  null
  
)

export default component.exports